<form [formGroup]="form" role="form" (ngSubmit)="loginUser(form.value)">
  <div>
    <mat-form-field class="full-width">
      <mat-label>{{ 'igo.auth.user' | translate }}</mat-label>
      <input
        matInput
        required
        placeholder="{{ 'igo.auth.user' | translate }}"
        formControlName="username"
      />
    </mat-form-field>
  </div>

  <div>
    <mat-form-field class="full-width">
      <mat-label>{{ 'igo.auth.password' | translate }}</mat-label>
      <input
        matInput
        required
        type="password"
        placeholder="{{ 'igo.auth.password' | translate }}"
        formControlName="password"
      />
    </mat-form-field>
  </div>

  <button matButton="elevated" type="submit">
    {{ 'igo.auth.login' | translate }}
  </button>
  @if (allowAnonymous) {
    <button
      matButton="elevated"
      class="anonymous"
      type="button"
      (click)="loginAnonymous()"
    >
      {{ 'igo.auth.accessAnonymous' | translate }}
    </button>
  }
  @if (error) {
    <div>
      <br />
      <font size="3" color="red">{{ error }}</font>
    </div>
  }
</form>

@if (loading) {
  <div class="loading-container">
    <mat-spinner [diameter]="40" />
  </div>
}
